import { composables } from "@orange-marmalade/paginate-this";
import * as navActions from "APP_ROOT/Nav/Notifications/actions";
import api from "APP_ROOT/api";

export const { expire: expireNotifications } = composables({
  listId: "notifications"
});
export const { expire: expireSearchNotifications, removeAsync } = composables({
  listId: "searchNotifications"
});

export function markDeleted(noteId) {
  return dispatch =>
    dispatch(
      removeAsync(
        noteId,
        api.notifications
          .update(noteId, { deleted_at: new Date() })
          .then(() => {
            dispatch(expireNotifications());
            return dispatch(navActions.expire());
          }),
        false
      )
    );
}

export function markRead(noteId) {
  return dispatch =>
    dispatch(
      removeAsync(
        noteId,
        api.notifications.update(noteId, { read: true }).then(() => {
          dispatch(expireNotifications());
          return dispatch(navActions.expire());
        }),
        false
      )
    );
}

export function markAllRead(filters) {
  return dispatch =>
    api.notifications.markAllRead(filters).then(() => {
      dispatch(expireNotifications());
      dispatch(expireSearchNotifications());
      dispatch(navActions.expire());
    });
}



// WEBPACK FOOTER //
// ./app/modules/Notifications/actions.js